import { Link } from 'react-router-dom';
import { ArrowRight, Compass } from 'lucide-react';
import { NOT_SURE } from '@/data/services';
import { Reveal } from '../Reveal';

// Section 7 — Not sure where to begin? Routes into the homepage's approved
// guided solution finder (same component, data model, validation and
// backend service) with source "Services Overview Solution Finder".
export const NotSurePanel = () => (
  <section aria-labelledby="not-sure-heading" data-testid="services-not-sure" className="bg-mist py-16 sm:py-24">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal>
        <div className="mx-auto flex max-w-3xl flex-col items-center rounded-2xl border border-slate-200 bg-white p-8 text-center sm:p-12">
          <span className="inline-flex h-12 w-12 items-center justify-center rounded-md bg-navy-900">
            <Compass className="h-5 w-5 text-gold-500" aria-hidden="true" />
          </span>
          <h2 id="not-sure-heading" data-testid="not-sure-heading" className="mt-6 text-balance text-3xl font-extrabold tracking-tight text-navy-900 sm:text-4xl">
            {NOT_SURE.heading}
          </h2>
          <p className="mt-4 max-w-xl text-base leading-relaxed text-slate-600 sm:text-lg">
            {NOT_SURE.copy}
          </p>
          <Link
            to={NOT_SURE.actionHref}
            data-testid="not-sure-start-btn"
            className="group mt-8 inline-flex items-center justify-center gap-2 rounded-md bg-navy-900 px-7 py-3.5 text-sm font-bold text-white transition-colors hover:bg-navy-700"
          >
            {NOT_SURE.actionLabel}
            <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5" aria-hidden="true" />
          </Link>
        </div>
      </Reveal>
    </div>
  </section>
);
